import * as React from "react";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { IconButton } from "components/common";
function Paginator({ currentPage, totalItems, itemsPerPage, onNewPage }) {
  const { t } = useTranslation("enterprise_security_app");
  const pages = useMemo(() => {
    if (totalItems === 0) return 1;
    if (itemsPerPage === 0) return 1;
    return Math.ceil(totalItems / itemsPerPage);
  }, [totalItems, itemsPerPage]);
  const disabledPrevious = useMemo(() => currentPage === 1, [currentPage]);
  const disabledNext = useMemo(() => currentPage === pages, [currentPage, pages]);
  const handleNextPage = () => {
    if (currentPage === pages) onNewPage(currentPage);
    onNewPage(currentPage + 1);
  };
  const handlePreviousPage = () => {
    if (currentPage === 1) onNewPage(currentPage);
    onNewPage(currentPage - 1);
  };
  if (pages === 1) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("small", null, t("paginator.page_info", { current: currentPage, total: pages })), /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "chevron_left",
      onClick: handlePreviousPage,
      title: t("paginator.previous_page"),
      disabled: disabledPrevious
    }
  ), /* @__PURE__ */ React.createElement(
    IconButton,
    {
      name: "chevron_right",
      onClick: handleNextPage,
      title: t("paginator.next_page"),
      disabled: disabledNext
    }
  )));
}
export default Paginator;
